import React, { Component, HTMLAttributes } from "react";
import classnames from "classnames";

export abstract class SimpleComponent extends Component<
    HTMLAttributes<HTMLElement>
> {
    protected abstract tag: string;
    protected abstract className: string;

    public render() {
        const { children, className, ...props } = this.props;
        return React.createElement(
            this.tag,
            {
                ...props,
                className: classnames({
                    [this.className]: true,
                    ...(className ? { [className]: true } : {}),
                }),
            },
            children,
        );
    }
}
